import {createSlice} from "@reduxjs/toolkit";

const userSlice = createSlice({
    name:"UserSlice",
    initialState:{
        userDetails:{
            user: localStorage.getItem("user") || '',
            loading:false,
            error:null,
        }
    },
    reducers:{
        loginStart(state,action){
            state.userDetails.loading = true;
            state.userDetails.error = null;
        },
        loginSuccess(state,action){
            // Set both localStorage and Redux state
            localStorage.setItem("user", action.payload);
            state.userDetails.user = action.payload;
            state.userDetails.loading = false;
            state.userDetails.error = null;
        },
        loginFailed(state,action){
            state.userDetails.user = '';
            state.userDetails.loading = false;
            state.userDetails.error = action.payload;
        },
        // Add this new action to update user when it changes
        updateUser(state, action) {
            localStorage.setItem("user", action.payload);
            state.userDetails.user = action.payload;
        }
    }
})

export const {loginStart, loginSuccess, loginFailed, updateUser} = userSlice.actions;
export default userSlice.reducer;